import React, { createContext } from 'react';
import { Toaster } from 'react-hot-toast';
import { toastService } from '@/services/toastService';

// Create toast context
const ToastContext = createContext();

/**
 * Toast provider component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} ToastProvider component
 */
export const ToastProvider = ({ children }) => {
  const value = {
    showSuccess: toastService.showSuccess,
    showError: toastService.showError,
    showWarning: toastService.showWarning,
    showInfo: toastService.showInfo,
    showLoading: toastService.showLoading,
    dismissToast: toastService.dismissToast,
    dismissAll: toastService.dismissAll,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toaster
        toastOptions={{
          className: '',
          style: {
            border: '1px solid #E5E7EB',
            padding: '16px',
            color: '#374151',
            fontSize: '14px',
            fontWeight: '500',
            borderRadius: '8px',
            boxShadow:
              '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          },
        }}
      />
    </ToastContext.Provider>
  );
};

export default ToastContext;
